class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// QJ SMART THREAD-CODE SEARCH (replaces the 2026-06-03 blanket quote hack)
// Only thread cross-reference searches — a known thread brand name plus a number,
// e.g. "Floriani 238" or "Isacord 5933" — get wrapped in quotes so Shopify does an
// exact-phrase match against the product description and returns the matching thread
// at the top. All other searches are left untouched so normal product search works.
// To add a brand customers search by, just add it (lowercase) to THREAD_BRANDS.
(function () {
  var THREAD_BRANDS = [
    'isacord',
    'robison-anton',
    'robison anton',
    'floriani',
    'madeira',
    'polyneon',
    'rayon',
    'thread of heraldry',
    'tioh',
  ];

  function isThreadCrossReference(value) {
    var query = value.toLowerCase();
    if (!/\d/.test(query)) return false;
    for (var i = 0; i < THREAD_BRANDS.length; i++) {
      if (query.indexOf(THREAD_BRANDS[i]) !== -1) return true;
    }
    return false;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/search"]')) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var value = input.value.trim();
      if (!value || value.charAt(0) === '"') return;
      if (isThreadCrossReference(value)) {
        input.value = '"' + value + '"';
      }
    },
    true
  );
})();
